module.exports = __webpack_public_path__ + "img/Valide.71fcbcef.svg";